import api from "./api";

// Rotas aninhadas: /api/roteiros/{roteiroId}/dias
// (o ParcelasController já tem esse padrão — seguimos a mesma convenção)

export async function listDias(roteiroId) {
  const { data } = await api.get(`/roteiros/${roteiroId}/dias`);
  return data;
}

export async function createDia(roteiroId, payload) {
  const { data } = await api.post(`/roteiros/${roteiroId}/dias`, payload);
  return data;
}

export async function updateDia(roteiroId, id, payload) {
  await api.put(`/roteiros/${roteiroId}/dias/${id}`, payload);
}

export async function deleteDia(roteiroId, id) {
  await api.delete(`/roteiros/${roteiroId}/dias/${id}`);
}

// Busca o PDF do dia avulso como Blob (header + contexto + 1 dia + footer,
// sem passageiros/financeiro). O frontend abre via blob URL em aba nova —
// JWT vem no axios interceptor, então window.open direto não funcionaria.
export async function fetchDiaPdfBlob(roteiroId, diaId) {
  const res = await api.get(`/roteiros/${roteiroId}/dias/${diaId}/pdf`, {
    responseType: "blob",
  });
  return res.data;
}

// ─── Documentos do dia ──────────────────────────────────────────────────
// Endpoints aninhados sob /api/roteiros/{roteiroId}/dias/{diaId}/documentos.
// Mesmas validações do upload de cliente (PDF/JPG/JPEG/PNG, 10 MB) — gates
// duplicados aqui pra dar feedback imediato no front antes do roundtrip.

export const DIA_DOC_ACCEPT_MIME = ".pdf,.jpg,.jpeg,.png";
export const DIA_DOC_MAX_SIZE_BYTES = 10 * 1024 * 1024;
export const DIA_DOC_ALLOWED_EXT = ["pdf", "jpg", "jpeg", "png"];

export async function listDocumentosDia(roteiroId, diaId) {
  const { data } = await api.get(
    `/roteiros/${roteiroId}/dias/${diaId}/documentos`
  );
  return data;
}

// Upload multipart. Sobrepõe documento com mesmo NomeOriginal no mesmo dia
// (regra aplicada no backend; aqui só enviamos o arquivo + descrição opcional).
export async function uploadDocumentoDia(roteiroId, diaId, arquivo, descricao) {
  const form = new FormData();
  form.append("arquivo", arquivo);
  if (descricao && descricao.trim()) form.append("descricao", descricao.trim());
  const { data } = await api.post(
    `/roteiros/${roteiroId}/dias/${diaId}/documentos`,
    form,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data;
}

// Baixa o arquivo via blob → <a download>, mesmo padrão de documento de
// cliente. JWT no axios interceptor; não dá pra usar window.open direto.
export async function downloadDocumentoDia(roteiroId, diaId, docId, nomeSugerido) {
  const res = await api.get(
    `/roteiros/${roteiroId}/dias/${diaId}/documentos/${docId}/download`,
    { responseType: "blob" }
  );
  const url = window.URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nomeSugerido || `documento-${docId}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export async function deleteDocumentoDia(roteiroId, diaId, docId) {
  await api.delete(`/roteiros/${roteiroId}/dias/${diaId}/documentos/${docId}`);
}

// Reaproveita o formatBytes do service de documentos do cliente sem importar
// pra cá (cada layer cuida do seu helper).
export function formatBytes(bytes) {
  if (bytes == null) return "—";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
}
